export enum GridSortMode {
  Fixed,
  ColumnHeader,
  Selection,
}
